var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"template-field__checkbox"},[_c('NcCheckboxRadioSwitch',{attrs:{"id":_vm.fieldId,"type":"switch"},on:{"update:modelValue":_vm.input},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v("\n\t\t"+_vm._s(_vm.fieldLabel)+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }